import { ServiceLayout } from "@/components/service/ServiceLayout";
import { ServiceFAQ } from "@/components/service/ServiceFAQ";
import { WebDevHero } from "@/components/web-development/HeroSection";
import { ProcessSection } from "@/components/web-development/ProcessSection";
import { ProjectShowcase } from "@/components/web-development/ProjectShowcase";
import { ServiceCTA } from "@/components/ui/ServiceCTA";
import { serviceFAQs } from "@/data/service-faqs";

const WebDevelopment = () => {
  return (
    <ServiceLayout serviceName="Web Development">
      <WebDevHero />
      <ProjectShowcase />
      <ProcessSection />
      <ServiceFAQ faqs={serviceFAQs["web-development"]} serviceName="Web Development" />
      <ServiceCTA serviceName="Web Development" />
    </ServiceLayout>
  );
};

export default WebDevelopment;